import styled from 'styled-components';

import { OnboardingPage } from '@/pages/Onboarding/components/Page';

export const PageStyles = styled(OnboardingPage)`
  background: #14111e !important;
  height: 100%;

  ion-content {
    position: relative;
    overflow: hidden;

    &::part(scroll) {
      padding: 0;
      display: flex;
      flex-direction: column;
    }
  }
`;
